import { render, staticRenderFns } from "./UserGoalsForm.vue?vue&type=template&id=5f7035f4&scoped=true&"
import script from "./UserGoalsForm.vue?vue&type=script&lang=js&"
export * from "./UserGoalsForm.vue?vue&type=script&lang=js&"
import style0 from "./UserGoalsForm.vue?vue&type=style&index=0&id=5f7035f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7035f4",
  null
  
)

export default component.exports